var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 121,
    viewBox: "0 0 120 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 120,
    height: 120,
    rx: 60,
    fill: "url(#paint0_linear_8087_55344)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.2484 44.9134C74.2484 44.9134 63.5481 41.3467 62.0889 40.8603C59.6571 40.0497 58.0358 40.8603 58.0358 40.8603C58.0358 40.8603 46.5249 44.5081 45.8764 44.9134C43.4445 46.5347 43.4445 48.1559 43.4445 48.1559C43.4445 48.1559 43.4445 61.9366 43.3634 62.7472C42.796 68.5838 47.9029 73.4475 49.9295 75.0688C50.4159 75.4741 51.3076 76.0415 52.1993 76.4469C54.7933 77.8249 59.9002 80.5 60.4677 80.5C61.2783 80.5 68.655 75.7984 70.1952 74.8256C76.6802 70.7725 76.6802 65.017 76.6802 65.017C76.6802 65.017 76.6802 49.9393 76.6802 48.0749C76.6802 45.724 74.2484 44.9134 74.2484 44.9134ZM67.7633 56.2622C66.9527 57.0728 58.8464 65.1791 58.8464 65.1791L53.4963 60.5585C53.4963 60.5585 53.172 59.5047 53.9827 58.6941C53.9827 58.6941 55.0365 58.1267 55.6039 58.6941C56.4145 59.5047 58.8464 61.126 58.8464 61.126L65.3314 54.641C65.3314 54.641 66.1421 53.8303 67.7633 54.641C67.6823 54.641 68.574 55.4516 67.7633 56.2622Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8087_55344",
    x1: 120,
    y1: 69.25,
    x2: 7.5,
    y2: 71.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C64F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4582FE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.3f5852aa50f57f529566d16a3acc3c82.svg";
export { ForwardRef as ReactComponent };